import type { Panel } from '@/types/dashboard';
import { generateUUID } from '@/utils/uuid';

const DEFAULT_CHART_CONFIG = {
  chartType: 'line' as const,
  series: [],
  showLegend: false,
};

const DEFAULT_CHAT_CONFIG = {
  mode: 'compact' as const,
  compactLimit: 3,
};

export function createPanel(type: Panel['type']): Panel {
  let config: Record<string, unknown> = {};
  if (type === 'chart') {
    config = { ...DEFAULT_CHART_CONFIG };
  } else if (type === 'chat') {
    config = { ...DEFAULT_CHAT_CONFIG };
  }
  return {
    id: `panel-${generateUUID()}`,
    type,
    x: 0,
    y: 0,
    w: 4,
    h: 2,
    config,
  };
}

export function addPanel(panels: Panel[], panel: Panel): Panel[] {
  return [...panels, panel];
}

export function removePanel(panels: Panel[], id: string): Panel[] {
  return panels.filter(p => p.id !== id);
}

export function updatePanel(panels: Panel[], id: string, updates: Partial<Panel>): Panel[] {
  return panels.map(p => p.id === id ? { ...p, ...updates } : p);
}

export function syncPanelPositions(panels: Panel[], layout: Array<{ i: string; x: number; y: number; w: number; h: number }>): Panel[] {
  const layoutMap = new Map(layout.map(l => [l.i, l]));

  return panels.map(panel => {
    const layoutItem = layoutMap.get(panel.id);

    if (!layoutItem) {
      return panel;
    }

    return {
      ...panel,
      x: layoutItem.x,
      y: layoutItem.y,
      w: layoutItem.w,
      h: layoutItem.h
    };
  });
}

export function updatePanelData(panels: Panel[], id: string, data: Panel['data']): Panel[] {
  return panels.map(p => {
    if (p.id !== id) {
      return p;
    }

    return {
      ...p,
      data,
      _dataLoaded: true,
      _isLoading: false,
      _loadError: null
    };
  });
}
